import { qs, qsa } from "@fluorescent/dom";

import { emit } from "@/glow/events";

const filtering = container => {
  const selectors = {
    filterForm: "[data-filter-form]",
    filterItemInput: "[data-filter-item-input]",
    inputByEscapedNameAttribute: name => `input[data-name-escaped="${name}"]`,
    inputByEscapedNameAndValueAttributes: (name, value) =>
      `input[data-name-escaped="${name}"][data-value-escaped="${value}"]`,
    rangeInput: "[data-range-input]",
    searchForm: "[data-search-form]",
    searchInput: "[data-search-input]",
    searchOptions: "[data-search-options]",
    searchWrapper: "[data-search-wrapper]",
  };

  const forms = qsa(selectors.filterForm, container);
  const searchWrapper = container.closest(selectors.searchWrapper);
  let formData, searchFormParams, searchParams;

  // If we're filtering the search page, we need to preserve the search-related search params
  if (searchWrapper) {
    const searchForm = qs(selectors.searchForm, searchWrapper);

    searchFormParams = {
      "q": qs(selectors.searchInput, searchForm).value,
      "options[prefix]": qs(selectors.searchOptions, searchForm).value,
    };
  }

  setParams();

  function setParams(form) {
    form = form || forms[0];
    formData = new FormData(form);
    searchParams = new URLSearchParams(formData).toString();
  }

  // Takes the updated form element and updates all other forms with the updated values
  // @param {*} target
  function syncForms(target) {
    if (!target) return;

    const targetInputs = qsa(selectors.filterItemInput, target);

    targetInputs.forEach(targetInput => {
      const { nameEscaped, valueEscaped } = targetInput.dataset;

      if (targetInput.type === "checkbox" || targetInput.type === "radio") {
        const items = qsa(
          selectors.inputByEscapedNameAndValueAttributes(
            nameEscaped,
            valueEscaped
          )
        );
        items.forEach(input => {
          input.checked = targetInput.checked;
        });
      } else {
        const items = qsa(selectors.inputByEscapedNameAttribute(nameEscaped));
        items.forEach(input => {
          input.value = targetInput.value;
        });
      }
    });
  }

  function clearRangeInputs() {
    const rangeInputs = qsa(selectors.rangeInput, container);
    rangeInputs.forEach(input => {
      input.value = "";
    });
  }

  function resetForms() {
    forms.forEach(form => {
      form.reset();
    });
  }

  return {
    getState() {
      return {
        url: searchParams,
      };
    },

    filtersUpdated(target, cb) {
      syncForms(target);
      setParams(target);
      emit("filters:updated");
      return cb(this.getState());
    },

    removeFilters(target, cb) {
      emit("filters:filter-removed");
      return cb({ url: target[0].getAttribute("data-url-to-remove") });
    },

    removeRange(cb) {
      clearRangeInputs();
      setParams();
      return cb(this.getState());
    },

    clearAll(cb) {
      resetForms();
      searchParams = searchWrapper
        ? new URLSearchParams(searchFormParams).toString()
        : "";

      return cb(this.getState());
    },
  };
};

export default filtering;
